// extracted by mini-css-extract-plugin
module.exports = {"link":"CropCompareSuccessMsg_link__3jyoa"};